import { render, staticRenderFns } from "./JSelectKssjd.vue?vue&type=template&id=188c2e4a&scoped=true"
import script from "./JSelectKssjd.vue?vue&type=script&lang=js"
export * from "./JSelectKssjd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188c2e4a",
  null
  
)

export default component.exports